import { render, staticRenderFns } from "./HsaStoreCarouselWidget.vue?vue&type=template&id=4c564a0f&scoped=true"
import script from "./HsaStoreCarouselWidget.vue?vue&type=script&lang=ts"
export * from "./HsaStoreCarouselWidget.vue?vue&type=script&lang=ts"
import style0 from "./HsaStoreCarouselWidget.vue?vue&type=style&index=0&id=4c564a0f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c564a0f",
  null
  
)

export default component.exports